import React from 'react';
import { Route, Switch } from 'react-router-dom';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import VerifyEmailContainer from './containers/VerifyEmailContainer';
import VerifyUserContainer from './containers/VerifyUserContainer';
import EmailVerificationContainer from './containers/EmailVerificationContainer';
import RootContainer from './containers/RootContainer';
import authReducer from './reducers';

const VerifyEmailRoute = () => (
  <RootContainer>
    <VerifyEmailContainer />
  </RootContainer>
);

const VerifyUserRoute = () => (
  <RootContainer>
    <VerifyUserContainer />
  </RootContainer>
);

const AuthRoutes = () => (
  <SentryBoundary owner={sentryConstants.TEAMS.IAM}>
    <Switch>
      <Route
        key="verify-email"
        component={VerifyEmailRoute}
        path="/verify-email"
      />
      <Route
        key="verify-user"
        component={VerifyUserRoute}
        path="/verify-user"
      />
      <Route
        key="email-verification"
        component={EmailVerificationContainer}
        path="/email-verification"
      />
    </Switch>
  </SentryBoundary>
);

export default dynamic(
  'apps.auth', attachReducer(authReducer),
)(AuthRoutes);
